import styled from "styled-components";
import { Form as ANTDForm } from "antd";

export const ModalSpamTitle = styled.span`
    font-size: 16px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #6c7485;
`;

export const ModalForm = styled(ANTDForm)`
    margin-top: 6px;
`;

export const LoadingDataUser = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 180px;
`;